export enum AssessmentParentTypeEnum {
  PrepopulatedFrom = "PrepopulatedFrom",
  AmendmentOf = "AmendmentOf",
}
